import { useQuery } from 'react-query';
import { API } from '../../../api';

export interface IFeeAndChargeListData {
  payload: {
    employerId?: string;
    outletId?: string;
    page: number;
  };
  data: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;
    count: number;
  };
}

export const initFeeAndChargeListPayload: IFeeAndChargeListData['payload'] = {
  page: 1,
};

const getFeeAndChargeList = (data: IFeeAndChargeListData['payload']) => {
  return API.newGet('/api/employer/all', data);
};

export const useGetFeeAndChargeList = (data: IFeeAndChargeListData['payload']) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useQuery(['feeAndChargeList', data], (): any => getFeeAndChargeList(data), {
    select: (res: IFeeAndChargeListData['data']) => {
      return res.data;
    },
  });
};
